/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OfferStatus = {
    MetaStateAutoDraftStatusautoDraft: '{meta_state=Auto Draft, status=auto_draft}',
    MetaStateNewStatusneedsReview: '{meta_state=New, status=needs_review}',
    MetaStateNewStatusreviewed: '{meta_state=New, status=reviewed}',
    MetaStateNewStatusreEngaged: '{meta_state=New, status=re_engaged}',
    MetaStateInNegotiationStatusofferWithBuyer: '{meta_state=In Negotiation, status=offer_with_buyer}',
    MetaStateInNegotiationStatusofferWithSeller: '{meta_state=In Negotiation, status=offer_with_seller}',
    MetaStateAcceptedStatusaccepted: '{meta_state=Accepted, status=accepted}',
    MetaStateRejectedStatusrejected: '{meta_state=Rejected, status=rejected}',
    MetaStateTerminatedStatusterminated: '{meta_state=Terminated, status=terminated}'
} as const;
export type OfferStatus = typeof OfferStatus[keyof typeof OfferStatus];


export function OfferStatusFromJSON(json: any): OfferStatus {
    return OfferStatusFromJSONTyped(json, false);
}

export function OfferStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferStatus {
    return json as OfferStatus;
}

export function OfferStatusToJSON(value?: OfferStatus | null): any {
    return value as any;
}

